import { Component, OnInit, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, take, tap } from 'rxjs/operators';
import { UserModel, BusinessModel, ResellerModel } from '@models/index';
import { AppFacadeService } from '@services/app-facade.service';
import { BusinessFacadeService } from '@services/business/business-facade.service';
import { USER_SITE_ADMIN, USER_BUSINESS_ADMIN, USER_RESELLER_ADMIN, USER_BUSINESS } from '@utilities/data-mock';
import { RouterFacadeService } from '@services/router-facade.service';
import { GMBFacadeService } from '@services/gmb/gmb-facade.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { Role } from '@enums/role.enum';
import { ResellersFacadeService } from '@services/resellers/resellers-facade.service';
import { AdminFacadeService } from '@services/admin-facade.service';

@Component({
  selector: 'app-user-box',
  templateUrl: './user-box.component.html',
  styleUrls: ['./user-box.component.sass']
})
export class UserBoxComponent implements OnInit, AfterViewInit, OnDestroy {
  _subs: Subscription = new Subscription();
  loggedUser$: Observable<UserModel> = this.appFacadeService.getLoggedUser$()
  selectedReseller$ = this.resellerFacadeService.getSelectedReseller$()
  selectedBusinessProfile$: Observable<BusinessModel> = this.businessFacadeService.getSelectedBusiness$()
  Role = Role;
  usersRoles: UserModel[] = [USER_SITE_ADMIN, USER_RESELLER_ADMIN, USER_BUSINESS_ADMIN, USER_BUSINESS]
  @Output() onLogout = new EventEmitter();
  @Output() onChangeUser = new EventEmitter();

  permissions: any;
  selectedReseller: ResellerModel;

  constructor(
    private appFacadeService: AppFacadeService,
    private routerFacadeService: RouterFacadeService,
    private resellerFacadeService: ResellersFacadeService,
    private businessFacadeService: BusinessFacadeService,
    private gmbFacadeService: GMBFacadeService,
    private activatedRoute: ActivatedRoute,
    private permissionsService: NgxPermissionsService,
    private router: Router,
    private adminFacadeService: AdminFacadeService,
  ) {
    this.permissions = this.permissionsService.getPermissions()

    // If the user is authenticating with Google from LocationReviewTargetComponent, do not handle.
    // TODO: do not use Window API here
    const lastPathComponent = window.location.toString().split('?')[0].split('/').pop();
    if (lastPathComponent != "location-review-targets") {
      this.activatedRoute.queryParams.pipe(
        take(1),
        map(params => params.code),
        filter(val => !!val),
        distinctUntilChanged()
      ).subscribe((code) => {
        this.gmbFacadeService.authenticateWithGoogle(code);

        // remove query string from URL
        this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: {} });
      });
    }
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    // not sure if this subscription has any side-effects, leaving here for now
    this._subs.add(
      this.googleAuthState.subscribe(_value => { })
    )
    this._subs.add(
      this.selectedReseller$.subscribe(reseller => {
        this.selectedReseller = reseller
      })
    );
  }

  ngOnDestroy() {
    this._subs.unsubscribe()
  }

  googleLogin() {
    this.gmbFacadeService.authenticateWithGoogle(null);
  }

  // null = either not attempted or loading; false = not authenticated; true = authenticated
  googleAuthState: Observable<null | false | true> = this.gmbFacadeService.getBusinesses$().pipe(
    map(list => {
      if (list !== null && list !== false) {
        return true;
      } else {
        return list as null | false;
      }
    })
  )

  googleRefresh() {
    this.gmbFacadeService.refreshBusinesses();
  }

  onChangePassword() {
    this.routerFacadeService.gotoChangePassword$();
  }

  navigateTo(pathUrl: string) {
    if (this.selectedReseller.id != null) {
      this.adminFacadeService.getResellerById(this.selectedReseller.id)
    }
    this.routerFacadeService.navigateTo$(pathUrl)
  }
}
